import script from "./contract-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./contract-template.vue?vue&type=script&lang=ts&setup=true"

import "./contract-template.vue?vue&type=style&index=0&id=6a6f5efc&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6f5efc"]])

export default __exports__